import {DependencyList, useCallback, useMemo} from 'react';

export function useSort<T>(content: T[], selector: (item1: T, item2: T) => number, deps: DependencyList = []) {
    const predicate = useCallback(selector, deps);
    return useMemo(() => content.sort(predicate), [content, predicate]);
}
